// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"121":"311fc6dc","642":"a530e103"}[chunkId] + ".js";
};